import { type FC } from 'react';

import { VerticalSlider } from 'shared/components/VerticalSlider';
import { type ArrayOfObjects } from 'shared/types/ArrayOfObjects';

import { Arrow } from './internal/components/Arrow';
import { CarouselSlide } from './internal/components/CarouselSlide';

type Slide = {
  imageSrc: string;
  title: string;
  description: string;
};

export type SpecialProjectCarouselProps = {
  media: ArrayOfObjects<Slide>;
};

export const Carousel: FC<SpecialProjectCarouselProps> = props => {
  const { media } = props;

  return (
    <VerticalSlider arrow={Arrow}>
      {media.map(slide => (
        <CarouselSlide description={slide.description} imageSrc={slide.imageSrc} key={slide.id} title={slide.title} />
      ))}
    </VerticalSlider>
  );
};
